import React from 'react';

import { FontAwesomeIcon } from '@schoolinks/ui-components';

import { lowerCase } from 'lodash';
import { faBookOpen } from '@fortawesome/pro-regular-svg-icons/faBookOpen';
import { faCalendarPlus } from '@fortawesome/pro-regular-svg-icons/faCalendarPlus';
// eslint-disable-next-line no-unused-vars
import { faChartLineDown } from '@fortawesome/pro-regular-svg-icons/faChartLineDown';
// eslint-disable-next-line no-unused-vars
import { faChartLineUp } from '@fortawesome/pro-regular-svg-icons/faChartLineUp';
import { faChartSimple } from '@fortawesome/pro-regular-svg-icons/faChartSimple';
import { faFaceFrown } from '@fortawesome/pro-regular-svg-icons/faFaceFrown';
import { faFaceSmile } from '@fortawesome/pro-regular-svg-icons/faFaceSmile';
import { faGear } from '@fortawesome/pro-regular-svg-icons/faGear';
import { faLightbulbOn } from '@fortawesome/pro-regular-svg-icons/faLightbulbOn';
import { faMessageLines } from '@fortawesome/pro-regular-svg-icons/faMessageLines';
import { faPartyHorn } from '@fortawesome/pro-regular-svg-icons/faPartyHorn';

import { faSirenOn } from '@fortawesome/pro-regular-svg-icons/faSirenOn';

import {
  OVERALL_CATEGORY,
  CHECKINS_ANSWER_CATEGORIES_WITH_OVERALL,
} from 'constants/checkins';

import USER_CAPABILITIES from 'constants/userCapabilities';

import {
  FILTER_GRADES,
  FILTER_SCHOOLS,
  FILTER_CASELOADS,
  FILTER_STUDENT_TAGS,
  FILTER_STUDENT_TAGS_OFFICIAL,
} from 'modules/StudentScopeFilter/constants';

export const MODULE_NAME = 'checkins';

export const SUGGESTED_LESSONS_TAB_ID = 'suggested-lessons';

export const TABS = t => [
  {
    id: 'overview',
    icon: <FontAwesomeIcon icon={faChartSimple} />,
    label: t('ElementaryCheckins.Constants.Overview', { debugAsText: true }),
  },
  {
    id: 'schedule',
    icon: <FontAwesomeIcon icon={faCalendarPlus} />,
    label: t('ElementaryCheckins.Constants.Schedule', { debugAsText: true }),
  },
  {
    id: SUGGESTED_LESSONS_TAB_ID,
    icon: <FontAwesomeIcon icon={faBookOpen} />,
    label: t('ElementaryCheckins.Constants.SuggestedLessons', {
      debugAsText: true,
    }),
  },
  {
    id: 'insights',
    icon: <FontAwesomeIcon icon={faLightbulbOn} />,
    label: t('ElementaryCheckins.Constants.Insights', { debugAsText: true }),
  },
  {
    id: 'settings',
    icon: <FontAwesomeIcon icon={faGear} />,
    label: t('ElementaryCheckins.Constants.Settings', { debugAsText: true }),
    capability: USER_CAPABILITIES.CAPABILITY_SEL_CHECKINS_SCHEDULE,
  },
];

export const STUDENT_SCOPE_FILTERS = [
  FILTER_GRADES,
  FILTER_SCHOOLS,
  FILTER_CASELOADS,
  FILTER_STUDENT_TAGS,
  FILTER_STUDENT_TAGS_OFFICIAL,
];

export const STUDENT_SCOPE_INSTANCE = 'elCheckinOverview';

/**
 * Overview
 */

/**
 * Dependant in CHECKINS_ANSWER_CATEGORIES in checkins/constants
 */
export const LATEST_ANSWERS_AXIS_LEFT_EMOJI_COORDINATES = {
  Emotional: { translateX: 102, translateY: 15 },
  Physical: { translateX: 90, translateY: 15 },
  Social: { translateX: 78, translateY: 15 },
  Cognitive: { translateX: 96, translateY: 15 },
};

export const WEEK = 'week';
export const TWO_WEEKS = 'two weeks';
export const MONTH = 'month';

export const TRENDS_DROPDOWN_OPTIONS = t => [
  {
    name: t('ElementaryCheckins.Constants.Past7Days', { debugAsText: true }),
    id: WEEK,
  },
  {
    name: t('ElementaryCheckins.Constants.Past14Days', { debugAsText: true }),
    id: TWO_WEEKS,
  },
  {
    name: t('ElementaryCheckins.Constants.Past30Days', { debugAsText: true }),
    id: MONTH,
  },
];

export const INSIGHTS_SORTING_OPTIONS = t => [
  {
    name: t('ElementaryCheckins.Constants.MostMatches', { debugAsText: true }),
    id: 'desc,user_survey_count',
  },
  {
    name: t('ElementaryCheckins.Constants.LeastMatches', { debugAsText: true }),
    id: 'asc,user_survey_count',
  },
  {
    name: t('ElementaryCheckins.Constants.NewestOldest', { debugAsText: true }),
    id: 'desc,last_survey_completed_datetime',
  },
  {
    name: t('ElementaryCheckins.Constants.OldestNewest', { debugAsText: true }),
    id: 'asc,last_survey_completed_datetime',
  },
];

export const DAYS_RANGE = {
  [WEEK]: 6,
  [TWO_WEEKS]: 13,
  [MONTH]: 29,
};

/**
 * Schedule
 */

export const GRADE_NAME_MAP = t => ({
  0: t('ElementaryCheckins.Constants.Grade.Kindergarten', {
    debugAsText: true,
  }),
  1: t('ElementaryCheckins.Constants.Grade.1stGrade', { debugAsText: true }),
  2: t('ElementaryCheckins.Constants.Grade.2ndGrade', { debugAsText: true }),
  3: t('ElementaryCheckins.Constants.Grade.3rdGrade', { debugAsText: true }),
  4: t('ElementaryCheckins.Constants.Grade.4thGrade', { debugAsText: true }),
  5: t('ElementaryCheckins.Constants.Grade.5thGrade', { debugAsText: true }),
  6: t('ElementaryCheckins.Constants.Grade.6thGrade', { debugAsText: true }),
  7: t('ElementaryCheckins.Constants.Grade.7thGrade', { debugAsText: true }),
  8: t('ElementaryCheckins.Constants.Grade.8thGrade', { debugAsText: true }),
  9: t('ElementaryCheckins.Constants.Grade.9thGrade', { debugAsText: true }),
  10: t('ElementaryCheckins.Constants.Grade.10thGrade', { debugAsText: true }),
  11: t('ElementaryCheckins.Constants.Grade.11thGrade', { debugAsText: true }),
  12: t('ElementaryCheckins.Constants.Grade.12thGrade', { debugAsText: true }),
});

/**
 * Insights
 */

export const INSIGHTS_LOADING_SKELETON_COUNT = 4;
export const INSIGHTS_LOADING_SKELETON_CHIPS_COUNT = 4;
export const DECREASED_ACTION = 'decreased';
export const REPORTED_ACTION = 'reported';
export const INCREASED_ACTION = 'increased';
export const WROTE_ACTION = 'wrote';
export const LEFT_NOTE_ACTION = 'left_note';
export const INSIGHTS_CARD_SIZE = 96;
export const INSIGHTS_PER_PAGE = 10;
export const INSIGHTS_DEFAULT_ORDER = 'desc';
export const INSIGHTS_DEFAULT_ORDER_BY = 'user_survey_count';
export const NEGATIVE_QUESTION_CHOICE_WEIGHTING = -1;
export const POSITIVE_QUESTION_CHOICE_WEIGHTING = 1;
export const NEGATIVE_ACTION_NAME = 'Chose a negative answer';
export const CELEBRATION_WORD_ACTION_NAME = 'Wrote a celebration word';

/**
 * Advanced Filter Options
 */

export const ACTIONS = [
  {
    id: REPORTED_ACTION,
    name: NEGATIVE_ACTION_NAME,
    translationKey: 'ElementaryCheckins.Constants.ChoseANegativeAnswer',
    icon: <FontAwesomeIcon color="red" icon={faFaceFrown} />,
  },
  {
    id: REPORTED_ACTION,
    name: 'Chose a positive answer',
    translationKey: 'ElementaryCheckins.Constants.ChoseAPositiveAnswer',
    icon: <FontAwesomeIcon color="green" icon={faFaceSmile} />,
  },
  {
    id: LEFT_NOTE_ACTION,
    name: 'Left a note',
    translationKey: 'ElementaryCheckins.Constants.LeftANote',
    icon: <FontAwesomeIcon color="blue" icon={faMessageLines} />,
  },
  {
    id: WROTE_ACTION,
    name: 'Wrote an alert word',
    translationKey: 'ElementaryCheckins.Constants.WroteAnAlertWord',
    icon: <FontAwesomeIcon color="red" icon={faSirenOn} />,
  },
  {
    id: WROTE_ACTION,
    name: CELEBRATION_WORD_ACTION_NAME,
    translationKey: 'ElementaryCheckins.Constants.WroteACelebrationWord',
    icon: <FontAwesomeIcon color="green" icon={faPartyHorn} />,
  },
  // {
  //   id: DECREASED_ACTION,
  //   name: 'A decreased score',
  //   icon: <FontAwesomeIcon icon={faChartLineDown} color="red" />,
  // },
  // {
  //   id: INCREASED_ACTION,
  //   name: 'An increased score',
  //   icon: <FontAwesomeIcon icon={faChartLineUp} color="green" />,
  // },
];

export const getTranslatedActions = t =>
  ACTIONS.map(action => ({
    ...action,
    name: t(action.translationKey, { debugAsText: true }),
  }));

export const DURATION_WEEKS = [
  {
    id: 1,
    name: 'Past 7 days',
    translationKey: 'ElementaryCheckins.Constants.Past7Days',
  },
  {
    id: 2,
    name: 'Past 14 days',
    translationKey: 'ElementaryCheckins.Constants.Past14Days',
  },
  {
    id: 4,
    name: 'Past 30 days',
    translationKey: 'ElementaryCheckins.Constants.Past30Days',
  },
];

export const getTranslatedDurationWeeks = t =>
  DURATION_WEEKS.map(duration => ({
    ...duration,
    name: t(duration.translationKey, { debugAsText: true }),
  }));

export const COUNT_OPTIONS = [
  {
    id: 1,
    name: 'At least 1 time',
    translationKey: 'ElementaryCheckins.Constants.AtLeast1Time',
  },
  {
    id: 2,
    name: 'At least 2 times',
    translationKey: 'ElementaryCheckins.Constants.AtLeast2Times',
  },
  {
    id: 3,
    name: 'At least 3 times',
    translationKey: 'ElementaryCheckins.Constants.AtLeast3Times',
  },
  {
    id: 4,
    name: 'At least 4 times',
    translationKey: 'ElementaryCheckins.Constants.AtLeast4Times',
  },
  {
    id: -1,
    name: 'On every check-in',
    translationKey: 'ElementaryCheckins.Constants.OnEveryCheckIn',
  },
];

export const getTranslatedCountOptions = t =>
  COUNT_OPTIONS.map(count => ({
    ...count,
    name: t(count.translationKey, { debugAsText: true }),
  }));

export const CATEGORIES = CHECKINS_ANSWER_CATEGORIES_WITH_OVERALL.map(
  category => ({
    id: lowerCase(category),
    name: `${category} score`,
  }),
);

/**
 * Advanced Default Filters
 */

export const DEFAULT_DURATION_WEEKS = 4;
export const DEFAULT_NUMBER_OF_TIMES = 1;
export const DEFAULT_ACTION = REPORTED_ACTION;
export const DEFAULT_CATEGORY = lowerCase(OVERALL_CATEGORY);

export const ADVANCED_FILTERS_DEFAULT_VALUES = {
  action: ACTIONS.find(({ id }) => id === DEFAULT_ACTION),
  category: CATEGORIES.find(({ id }) => id === DEFAULT_CATEGORY),
  durationWeeks: DURATION_WEEKS.find(({ id }) => id === DEFAULT_DURATION_WEEKS),
  comparedDurationWeeks: DURATION_WEEKS.find(
    ({ id }) => id === DEFAULT_DURATION_WEEKS,
  ),
  count: COUNT_OPTIONS.find(({ id }) => id === DEFAULT_NUMBER_OF_TIMES),
};

export const CAPABILITY_DISABLED_TAB_MESSAGE =
  "To access this feature, your district's SchooLinks administrator must grant you the following capability: Schedule student check-ins";

export const ALL_GRADES_LABEL = 'All grades';
export const ALL_SCHOOLS_LABEL = 'All schools';
